export enum StatusEnum {
    None, // default value 
    Success,
    Warning,
    Error,
    InvalidSupplier
}

export class Status {
    type: StatusEnum;
    message: string;

    constructor(type: StatusEnum, message: string = null) {
        this.type = type;
        this.message = message;
    }
}

export class StatusMessage {
    SuccessTitle: string = "Success";
    SuccessMessage: string = "Success";

    WarningTitle: string = "Warning";
    WarningMessage: string  = "Warning";

    ErrorTitle: string = "Error";
    ErrorMessage: string = "Something went wrong!";

    InvalidSupplierTitle: string = "InvalidSupplier";
    InvalidSupplierMessage: string = "InvalidSupplier";
}